import { ReactNode } from 'react';
import {
  TabPanel as ReakitTabPanel,
  TabOptions,
  TabPanelHTMLProps,
} from 'reakit/Tab';
import { useSpring, animated } from 'react-spring';

interface TabPanelProps extends TabPanelHTMLProps {
  tab: TabOptions;
  id: string;
  children: ReactNode;
}

export default function TabPanel({
  tab,
  id,
  children,
  ...rest
}: TabPanelProps) {
  const isActive = tab.selectedId === id;
  const spring = {
    from: {
      opacity: 0,
      transform: `translateY(-10%)`,
      pointerEvents: `none`,
      zIndex: 0,
    },
    to: {
      opacity: isActive ? 1 : 0,
      transform: isActive ? `translateY(0px)` : `translateY(-10%)`,
      pointerEvents: isActive ? `` : `none`,
      zIndex: isActive ? 1 : 0,
    },
  } as const;

  const styles = useSpring(spring);

  return (
    <animated.div style={styles}>
      <ReakitTabPanel {...tab} {...rest}>
        {children}
      </ReakitTabPanel>
    </animated.div>
  );
}
